import { useGetFeatureFlagsQuery } from './featureFlagsApi'

export interface FeatureFlagHook {
  /** Whether the gate is on. Falls back to `defaultValue` while loading, on a failed request, or if the key is absent. */
  isEnabled: boolean
  isLoading: boolean
}

/**
 * Read a single backend-fed development gate.
 *
 *   const { isEnabled } = useFeatureFlag('show_experimental_feature')
 *
 * Backed by a cached RTK Query call to the backend. This hook does not poll: a
 * flag toggled in AppConfig is reflected only on the next fetch of this query
 * (page reload, manual refetch, or cache invalidation), not automatically. It
 * returns `defaultValue` while the request is in flight, if the request fails,
 * or if the key is absent.
 */
export function useFeatureFlag(
  flagKey: string,
  defaultValue = false,
): FeatureFlagHook {
  const { data, isLoading } = useGetFeatureFlagsQuery()
  const isEnabled = data?.flags?.[flagKey] ?? defaultValue
  return { isEnabled, isLoading }
}
